import { useEffect } from 'react';
import axios from 'axios'
import { message } from 'antd'

function App() {
  useEffect(() => {
    const windowUrl = window.location.search
    const params = new URLSearchParams(windowUrl)

    const redirectUrl = params.get('redirectUrl')
    const openId = params.get('openid')
    const templateId = params.get('template_id')
    const action = params.get('action')
    const scene = params.get('scene')
    if(redirectUrl && openId && templateId && scene && action === 'confirm') {
        redirectUrl.startsWith('https://mcp') &&
        (window.location.href = `${redirectUrl}&openId=${openId}&templateId=${templateId}&action=${action}&scene=${scene}`)
    }
    else if(redirectUrl && templateId && scene && action === 'cancel') {
        redirectUrl.startsWith('https://mcp') &&
        (window.location.href = `${redirectUrl}&templateId=${templateId}&action=${action}&scene=${scene}`)
    }

    const to = params.get('to')
    const info = params.get('info')
    const urlSchemeFormLocalStorage = localStorage.getItem("urlScheme")
    const infoFormLocalStorage = localStorage.getItem("info")
    if (to) {
      to.startsWith('weixin://dl/business/?t=') && (window.location.href = to)
    }
    else if( urlSchemeFormLocalStorage && (info === infoFormLocalStorage) ) {
      urlSchemeFormLocalStorage.startsWith('weixin://dl/business/?t=') && (window.location.href = urlSchemeFormLocalStorage)
    }
    else if(info) {
        axios(`${process.env.REACT_APP_SOCIAL_BASE_URL}/v1/url-scheme`,{
          method: 'GET',
          params: {
              info
          }
        })
            .then(({ data }) => {
              const { urlScheme } = data
              localStorage.setItem("urlScheme", urlScheme)
              localStorage.setItem("info", info)
              urlScheme.startsWith('weixin://dl/business/?t=') && (window.location.href = urlScheme)
            }).catch(() => {
                message.error("出了点问题，请稍后再试！")
            })
    }
  }, [])
  return null;
}

export default App;
